// Exports
export default {
	"DotSpin": "DotSpin_JsYMK",
	"DotSpin__dot": "DotSpin__dot_tSmDK",
	"dot-bounce-animation": "dot-bounce-animation_IalH5"
};
